import { useParams } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
// @ts-ignore js file is not typed
import { getUser } from '../selectors/userSelectors';
import { useSelector } from 'react-redux';
import { ProfilePage } from 'academy-common-lib/features/profile/containers/Profile/ProfilePage';
import usageTracker from '../utils/UsageTracker';
import EditProfileContainer from 'academy-common-lib/features/profile/containers/EditProfile/EditProfileContainer';
import { useCallback } from 'react';
import { EDIT_PROFILE_URL_FRAGMENT } from '../constants/Navigation.legacy';
import { useGetUserProfile } from 'academy-common-lib/features/profile/data/userProfile';
import { usePageTitle } from '../hooks/usePageTitle.legacy';
import { useHasGate } from '../features/accounts';
import { jsx as _jsx } from "react/jsx-runtime";
const Profile = ({
  profileId
}) => {
  var _userProfileData$user;
  const user = useSelector(getUser);
  const {
    data: userProfileData
  } = useGetUserProfile(parseInt(profileId, 10));
  const displayName = userProfileData === null || userProfileData === void 0 || (_userProfileData$user = userProfileData.user_profile) === null || _userProfileData$user === void 0 ? void 0 : _userProfileData$user.displayName;
  const isOwnProfile = user.user_id.toString() === profileId;
  const {
    hasGate: hasBadgeShareGate
  } = useHasGate('Academy:BadgeShare');
  usePageTitle({
    i18nKey: isOwnProfile ? 'learningCenter.pageTitles.myProfile' : 'learningCenter.dynamicPageTitles.profileName',
    options: !isOwnProfile && displayName ? {
      displayName
    } : undefined,
    skip: !isOwnProfile && !displayName
  });
  const trackPageView = useCallback(() => {
    usageTracker.track('pageView', {
      screen: 'profile',
      profileId
    });
  }, [profileId]);
  const trackInteraction = useCallback((action, extraProperties) => {
    usageTracker.track('interaction', Object.assign({
      action,
      screen: 'my-profile'
    }, extraProperties));
  }, []);
  return /*#__PURE__*/_jsx(ProfilePage, {
    authedUser: {
      id: user.user_id,
      email: user.email
    },
    editPath: EDIT_PROFILE_URL_FRAGMENT,
    failureMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_LOAD_FAILURE"
    }),
    notFoundMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_NOT_FOUND_LOAD"
    }),
    profileId: profileId,
    showBadgeShareButton: hasBadgeShareGate === true,
    showHeader: false,
    successMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "PROFILE_LOAD"
    }),
    trackInteraction: trackInteraction,
    trackPageView: trackPageView
  });
};
export const MyProfile = () => {
  const user = useSelector(getUser);
  return /*#__PURE__*/_jsx(Profile, {
    profileId: user.user_id.toString()
  });
};
export const UserProfile = () => {
  const {
    userId: userIdParam
  } = useParams();
  return /*#__PURE__*/_jsx(Profile, {
    profileId: userIdParam
  });
};
export const EditProfile = () => {
  const user = useSelector(getUser);
  const trackPageView = useCallback(() => {
    usageTracker.track('pageView', {
      screen: 'edit profile'
    });
  }, []);
  return /*#__PURE__*/_jsx(EditProfileContainer, {
    authedUser: {
      id: user.user_id
    },
    showHeader: false,
    successMarker: /*#__PURE__*/_jsx(NavMarker, {
      name: "EDIT_PROFILE_LOAD"
    }),
    trackInteraction: interaction => usageTracker.track('interaction', {
      action: interaction
    }),
    trackPageView: trackPageView
  });
};